export default {
  formErrorRequired: `21022019-105513-0044`,
  // formErrorRequiredTrue: `This {{fName}} is required due the {{name}} field`, // TODO Localization
  formErrorMin: `21022019-105513-0045`,
  formErrorMax: `21022019-105513-0046`,
  formErrorEmail: `02042019-142619-0005`,
  formErrorMinLength: `21022019-105513-0048`,
  formErrorMaxLength: `21022019-105513-0049`,
  formErrorPattern: `21022019-105513-0050`,
  formErrorPhone: `12022018-160457-7813`,
  cannotCheckPhone: `21022019-105513-0051`,
  formErrorFormat: `23112016-083710-9436`
};
